import { Pipe, PipeTransform } from '@angular/core';

import { OptionsService } from '../services/options.service';

@Pipe({
    name: 'optionsSearchPipe'
})
export class OptionsSearchPipe implements PipeTransform {

    constructor(private os: OptionsService) { }

    transform(value: any[], searchTerm: KeyboardEvent, identifier?: string) {
        if (value && searchTerm) {
            let options;
            if (searchTerm.target['value'] === '') {
                options = value;
            } else {
                if (value.filter(x => (x.Visible !== undefined && x.Visible !== null && x.Visible === true)
                    && ((x.OptionDescription !== undefined && x.OptionDescription.toLowerCase().includes(searchTerm.target['value'].toLowerCase()))
                        || (x.OptionNumber !== undefined && x.OptionNumber.toString().includes(searchTerm.target['value']))
                        || (x.OptionDesc !== undefined && x.OptionDesc.toLowerCase().includes(searchTerm.target['value'].toLowerCase())))).length > 0) {
                    options = value.filter(x => (x.Visible !== undefined && x.Visible !== null && x.Visible === true)
                        && ((x.OptionDescription !== undefined && x.OptionDescription.toLowerCase().includes(searchTerm.target['value'].toLowerCase()))
                            || (x.OptionNumber !== undefined && x.OptionNumber.toString().includes(searchTerm.target['value']))
                            || (x.OptionDesc !== undefined && x.OptionDesc.toLowerCase().includes(searchTerm.target['value'].toLowerCase()))));
                } else {
                    options = [{ noMatches: true, message: 'No matches found.' }];
                }
            }

            value.forEach((op) => {
                if (op.Visible !== undefined && op.Visible !== null && op.Visible === true) {
                    if (op.SubOptions !== undefined && op.SubOptions.length > 1) {
                        if (op.SubOptions.filter(x => x.OptionDescription.toLowerCase().includes(searchTerm.target['value'].toLowerCase())).length > 0) {
                            if (!options.find(x => x.OptionId === op.OptionId)) {
                                options.push(op);
                            }
                        }
                    }
                }
            });
            if (options.find(x => { return x.noMatches })) {
                let temp: Array<string>;
                this.os.noMatches.subscribe(x => temp = x);
                temp.push(identifier);
                this.os.noMatches.next(temp);
            } else {
                this.os.noMatches.next([]);
            }
            return options.sort((op1, op2) => {
                return op2.Quantity - op1.Quantity || op2.SubOptionCount - op1.SubOptionCount;
            });;
        } else {
            this.os.noMatches.next([]);
            return value;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/pipes/options-search.pipe.ts